module.exports = "/assets/46d9174397b90e79f82807dc45d76700.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PS.png
// module id = 1727
// module chunks = 0